// extracted by mini-css-extract-plugin
export default {"container":"ProductInfoPage_container__Lov8l","emptyState":"ProductInfoPage_emptyState__h5BO8","image":"ProductInfoPage_image__u9gtE"};